import {
  api_cancel_team_subscription_path,
  api_create_gift_subscription_path,
  api_create_team_members_subscriptions_path,
  api_email_validation_path,
  api_group_finalize_total_amount_path,
  api_group_subscriptions_path,
  api_team_subscription_path,
  api_update_gift_subsciption_path,
  api_validate_new_recipient_path,
} from '../../routes';
import request from './request';
import { TeamResponse } from './teams';

export const GROUP_SUBSCRIPTION_KEY = 'group_subscription_key';
export type GroupSubscriptionType = 'Team Subscription' | 'Gift Subscription';

export interface GroupSubscriptionRecipient {
  email: string;
  paidThroughDate: string;
  autoRenew: boolean;
  recipientId: number;
}

export interface GiftSubscriptionParams {
  emails: string;
  notes: string;
  autoRenew: boolean;
}

export interface UpdateGroupSubscriptionParams {
  autoRenew: boolean;
  recipientId: number;
}

export interface CancelTeamSubscriptionParams {
  recipient_id: number;
}

export interface CancelTeamSubscriptionResponse {
  message?: string;
  success: boolean;
}

export interface ValidateGiftRecipientParams {
  email: string;
}

export interface FinalizeGiftPurchaseParams {
  group_subscription_type: GroupSubscriptionType;
  emails?: string[];
}

export interface CreateGiftSubscriptionResponse {
  message: string;
  code?: string;
}

export interface UpdateGiftSubscriptionResponse {
  message: string;
}

export interface ValidateGiftRecipientResponse {
  success: boolean;
}

export interface FinalizeGiftPurchaseResponse {
  totalPrice: number;
  subscribeThroughDate: string;
  unitPrice: number;
  totalEligibleSubs?: number;
}

export interface CreateTeamSubscriptionParams {
  guid: string;
  email?: string;
}

export interface GetGroupSubscriptionParams {
  type?: 'Team Subscription';
}

export interface CurrentOffer {
  initialPrice: number;
  discountedPercentageOff: number;
}

export async function giftSubscription(
  params: GiftSubscriptionParams
): Promise<CreateGiftSubscriptionResponse> {
  const resp = await request('post', api_create_gift_subscription_path(params));
  return resp;
}

export async function updateGroupSubscription(
  params: UpdateGroupSubscriptionParams
): Promise<UpdateGiftSubscriptionResponse> {
  const resp = await request('put', api_update_gift_subsciption_path(params));
  return resp;
}

export async function cancelTeamSubscription(
  params: CancelTeamSubscriptionParams
): Promise<CancelTeamSubscriptionResponse> {
  const resp = await request('put', api_cancel_team_subscription_path(params));
  return resp;
}

export async function validateGiftRecipient(
  params: ValidateGiftRecipientParams
): Promise<ValidateGiftRecipientResponse> {
  const resp = await request('get', api_validate_new_recipient_path(params));
  return resp;
}

export async function confirmGift(
  params: FinalizeGiftPurchaseParams
): Promise<FinalizeGiftPurchaseResponse> {
  const resp = await request('get', api_group_finalize_total_amount_path(params));
  return resp;
}

export async function getGroupSubscription(params?: GetGroupSubscriptionParams) {
  const resp = await request('get', api_group_subscriptions_path(params));
  return resp?.recipients;
}

export async function createTeamSubscription(
  params: CreateTeamSubscriptionParams
): Promise<UpdateGiftSubscriptionResponse> {
  const resp = await request('post', api_team_subscription_path(params));
  return resp;
}

export async function createTeamMembersSubscriptions(values: string[]): Promise<TeamResponse> {
  const resp = await request('post', api_create_team_members_subscriptions_path(), {
    team: { emails: values },
  });
  return resp;
}

export async function emailVerification(
  params: ValidateGiftRecipientParams
): Promise<ValidateGiftRecipientResponse> {
  const resp = await request('get', api_email_validation_path(params));
  return resp;
}
